import { FeatureFlagRepository } from '../../domain/repositories/FeatureFlagRepository';
import { FeatureFlag } from '../../domain/values/FeatureFlag';

export class FeatureFlagBuildEnvRepository implements FeatureFlagRepository {
    private _enabledFlags?: FeatureFlag[] = undefined;

    reset = () => {
        this._enabledFlags = undefined;
    };

    isEnabled = async (feature: FeatureFlag): Promise<boolean> => {
        this._enabledFlags = this._enabledFlags || (await this.loadFeatureFlags());
        return this._enabledFlags.includes(feature);
    };

    private async loadFeatureFlags(): Promise<FeatureFlag[]> {
        return [...(process.env.FF_DUMMY_FEATURE_FLAG ? [FeatureFlag.DUMMY_FEATURE_FLAG] : [])];
    }
}
